import {Api} from '../../../Api.js'

const RESOURCE = 'discount'

export default {
    resource: RESOURCE,
    prefix: 'shop/',
    query(query) {
        return Api().get(this.prefix + this.resource + (query ? query : ''))
    },
    get(id) {
        return Api().get(this.prefix + this.resource + '/' + id)
    },
    create(data) {
        return Api().post(this.prefix + this.resource, data)
    },
    update(id, data) {
        return Api().put(this.prefix + this.resource + '/' + id, data)
    },
    delete(id) {
        return Api().delete(this.prefix + this.resource + '/' + id)
    },
    duplicate(id) {
        return Api().get(this.prefix + this.resource + '/duplicate/' + id)
    }
}


// WEBPACK FOOTER //
// ./src/modules/shop/discount/DiscountService.js